import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/about.scss";

function About() {
  return (
    <div className="about">
      <Header />
      <main className="about-content">
        <div className="about-header">
          <h1 className="about-title">About Us</h1>
          <p className="about-subtitle">Discover the studio, materials, production, and design.</p>
        </div>
        <div className="about-image-full"><img src="/main/shiskerstone/studio.svg#view-1" alt="Jewelry design work in the shiskerstone studio" /></div>
        <div className="about-row">
          <div className="about-text">
            <h2>Discover the studio</h2>
            <p>shiskerstone is an independent jewelry and objects studio focused on expressive form, lasting materials, and pieces that become personal through wear.</p>
            <p>Each collection begins with hand sketches and small studies in wax or metal. Curved silhouettes, contrasting surfaces, pearls, and natural stones are developed slowly so every piece feels distinctive while remaining easy to live with.</p>
          </div>
          <div className="about-image"><img src="/main/shiskerstone/studio.svg#view-2" alt="Studio tools and jewelry models" /></div>
        </div>
        <div className="about-row">
          <div className="about-image"><img src="/main/shiskerstone/studio.svg#view-3" alt="Jewelry being finished by hand" /></div>
          <div className="about-text">
            <h2>Materials</h2>
            <p>We choose precious metals, freshwater pearls, enamel, and natural stones for their durability and individual character. Variations in tone, pattern, and shape are celebrated as part of each piece.</p>
            <p>Where practical, recycled metals and responsibly sourced materials are preferred. Pieces are designed for repair, care, and long-term use.</p>
            <h2 className="mt-section">Production</h2>
            <p>Our pieces are produced in small quantities with specialist makers. Hand finishing, stone setting, polishing, and quality checks are completed in considered stages to reduce unnecessary waste and preserve the intended detail.</p>
          </div>
        </div>
        <div className="about-image-full"><img src="/main/shiskerstone/studio.svg#view-4" alt="Natural stones and recycled metal in the studio" /></div>
        <div className="about-row">
          <div className="about-image"><img src="/main/shiskerstone/studio.svg#view-5" alt="Goldsmith working at a studio bench" /></div>
          <div className="about-text">
            <h2>Our Design Approach</h2>
            <p>shiskerstone balances strong silhouettes with practical details. The work is guided by material, proportion, and movement rather than by a single historical reference, allowing every collection to evolve in its own direction.</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default About;
